/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/inviteUser.config.json";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";
import { StorageModule } from "@vlinder-web/storage-module-react";

import { useOrgId } from "../provider";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { INVITE_CREDIT_UNION_USER } from "../graphql";
import moment from "moment-timezone";

const getStorageSrv = StorageModule?.getInstance();

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const LoginPageServ = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export interface InviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  userRoles: boolean;
  loginRestAPI: string;
  headers: any;
  termsOfUse: any;
}
export interface IInviteUserMethods extends IPluginMethodMap {
  getInviteUser(args: InviteUserProps): Promise<any>;
}

export class InviteUserService implements IAgentPlugin {
  readonly methods: IInviteUserMethods;

  constructor() {
    this.methods = {
      getInviteUser: this.getInviteUser.bind(this),
    };
  }

  async getInviteUser(args: InviteUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { orgId } = useOrgId();
    console.log(`args in invite user service`, args);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: INVITE_CREDIT_UNION_USER,
          variables: {
            input: {
              invite:
                args?.termsOfUse && args?.termsOfUse[0] === "inviteUser"
                  ? true
                  : false,
              user: {
                firstName: args?.firstName,
                lastName: args?.lastName,
                email: args?.email,
              },
              org: this.getOrgnizationId(),
              role: await this.getRole(args?.userRoles),
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }

  private getOrgnizationId() {
    let orgId = getStorageSrv?.get("myProfile", "session")?.org?.orgId;
    return orgId;
  }

  private async getRole(roles: any) {
    console.log(`roles:`, roles);
    let adminRole =
      Array.isArray(roles) && roles?.find((item) => item?.name === "admin");
    console.log(`admin Role`, adminRole);
    return adminRole?.uuid;
    // const user = await getWhoamiSrv()?.whoAmI();
    // if(user?.whoami === "RISK_CAPITAL"){
    //   return null
    // }
    // else{
    //   return null
    // }
  }
}
